<template>
  <div class="w-100 h-100 d-flex flex-column overflow-hidden">
    <iframe
      src="/ui-lib/index.html"
      class="w-100 h-100 border-0"
      title="JobNav UI Component Library"
    />
  </div>
</template>
